import { MrbBaseRouteStore } from "mrb/core";
import {
    AppStoreHomeSectionService,
    MediaVaultStreamService,
    NakiStoreFeaturedSectionFileStreamService,
} from "common/services";
import moment from "moment";

class NakiStoreFeaturedSectionRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(AppStoreHomeSectionService);
        this.mediaVaultStreamService = new MediaVaultStreamService(
            this.rootStore.apiClient,
            this.rootStore.application.baasic
        );
        this.nakiStoreFeaturedSectionFileStreamService = this.rootStore.createApplicationService(
            NakiStoreFeaturedSectionFileStreamService
        );
    }

    async getFeatured() {
        const response = await this.service.getNakiFeatured({
            embed: "nakiNigunAlbum,nakiNigunArtist,podcast",
        });
        return response.data;
    }

    async updateFeatured(resources) {
        const response = await this.service.updateNakiFeatured(resources);
        return response.data;
    }

    async getContent(filter) {
        const response = await this.service.getNakiContent(filter);
        return response.data;
    }

    getMediaVaultFileUrl(id) {
        return this.mediaVaultStreamService.mediaVaultModule.streams.routeDefinition.get(id);
    }

    async uploadImageFile(file) {
        const now = moment();
        const [name, extension] = file.name.split(".");
        const path = `${name}_${now.year()}-${now.month()}-${now.date()}-${now.hour()}-${now.minute()}-${now.second()}.${extension}`;
        const response = await this.mediaVaultStreamService.create(
            {
                path: path,
                fileName: file.name,
            },
            file
        );
        return response.data;
    }

    getFeaturedSectionCoverImageUrl(fileEntryId) {
        return this.nakiStoreFeaturedSectionFileStreamService.routeService.get(fileEntryId);
    }
}

export default NakiStoreFeaturedSectionRouteStore;
